import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import type { IIntegrationsNextResponse } from "@app/dashboard/types/innerLayout/payment_integrations/get-integrations";
import type { AxiosRequestConfig } from "axios";

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  allow403?: boolean;
};

export const getIntegrations = (pageSize: number) => {
  const params = { page_size: pageSize };

  return axiosPrivate.get(`/dashboard/api/v1/integrations/`, { params: params });
};

export const getIntegrationsNext = (params: {
  currency: string;
  isLive: boolean;
  isInvoice?: boolean;
}) => {
  const config = { allow403: true } as CustomAxiosRequestConfig;

  const queryParams = {
    currency: params.currency,
    is_live: params.isLive,
    is_invoice: params.isInvoice ?? true,
  };  

  return axiosPrivate.get<IIntegrationsNextResponse>(
    `/dashboard/api/v1/integrations/next`,
    {
      ...config,
      params: queryParams
    }
  );
};

export const getIntegrationsCurrencies = (params: { isLive: boolean }) => {
  const queryParams = {
    is_live: params.isLive,
  };

  return axiosPrivate.get<string[]>(
    `/dashboard/api/v1/integrations/currencies`,
    {
      params: queryParams,
    }
  );
};
